function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { omit } from "lodash-es";
import { Close } from "../../icons";
const Tag = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("div", _extends({}, omit(props, "onClose"), {
  ref: ref,
  className: classNames("tag", {
    [props.className]: props.className
  })
}), /*#__PURE__*/React.createElement("div", null, props.children), /*#__PURE__*/React.createElement(Close, {
  onClick: props.onClose
})));
Tag.defaultProps = {
  className: undefined,
  children: undefined
};
Tag.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
};
export default Tag;
//# sourceMappingURL=Tag.js.map